import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Dropdown, FormControl } from "react-bootstrap";
import "./Filtri.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store";
import { urlcommittenti } from "../lib/api.ts";
import { allGet } from "../Redux/Actions.tsx";

interface FormFiltriClientiProps {
  onClose: () => void;
  setTable: (x: any) => void;

  // Ricevi lo stato e la funzione di update dal padre
  filtroCliente: {
    ragioneSociale: string;
    protocollo: string;
    partitaIva: string;
    sdi: string;
    codiceFiscale: string;
    citta: string;
    cap: string;
  };
  setFiltroCliente: React.Dispatch<
    React.SetStateAction<{
      ragioneSociale: string;
      protocollo: string;
      partitaIva: string;
      sdi: string;
      codiceFiscale: string;
      citta: string;
      cap: string;
    }>
  >;
}

const tipologiaOptions = [
  { label: "Privato", value: "PRIVATO" },
  { label: "Persona Fisica Titolare di Partita IVA", value: "PFTPI" },
  { label: "Soggetto Diverso da Persona Fisica", value: "SDPF" },
];

const FormFiltriClienti: React.FC<FormFiltriClientiProps> = ({
  onClose,
  setTable,
  filtroCliente,
  setFiltroCliente,
}) => {
  const [ragioneSearchText, setRagioneSearchText] = useState("");
  const [pivaSearchText, setPivaSearchText] = useState("");
  const [sdiSearchText, setSdiSearchText] = useState("");
  const [protocolloSearchText, setProtocolloSearchText] = useState("");

  const [arrayProtocollo, setArrayProtocollo] = useState<string[]>([]);

  const { committenti } = useSelector((state: RootState) => state.committenti);
  const { token } = useSelector((state: RootState) => state.login);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    if (committenti.length > 0) {
      const anniProtocollo = committenti
        .map((c) => {
          if (typeof c.protocollo === "string") {
            const parts = c.protocollo.split("_");
            return parts[1];
          }
          return null;
        })
        .filter((anno): anno is string => anno !== null)
        .filter((anno, index, self) => self.indexOf(anno) === index);

      setArrayProtocollo(anniProtocollo);
    }
  }, [committenti]);

  const handleChange = (name: string, value: string) => {
    setFiltroCliente((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    let url = urlcommittenti + "/filter?";
    if (filtroCliente) {
      if (filtroCliente.ragioneSociale)
        url += `ragioneSociale=${filtroCliente.ragioneSociale}`;
      if (filtroCliente.protocollo) url += `anno=${filtroCliente.protocollo}`;
      if (filtroCliente.codiceFiscale)
        url += `&codiceFiscale=${filtroCliente.codiceFiscale}`;
      if (filtroCliente.partitaIva)
        url += `&partitaIva=${filtroCliente.partitaIva}`;
      if (filtroCliente.sdi) url += `&sdi=${filtroCliente.sdi}`;
      if (filtroCliente.citta) url += `&citta=${filtroCliente.citta}`;
      if (filtroCliente.cap) url += `&cap=${filtroCliente.cap}`;
    }

    if (url !== urlcommittenti + "/filter?") {
      dispatch(allGet(url, token)).then((arrayCantieri) => {
        if (arrayCantieri) {
          const formattedCommittenti = arrayCantieri.map(
            (committente: any) => ({
              ...committente,
              tipologia:
                tipologiaOptions.find(
                  (option) => option.value === committente.tipologia
                )?.label || "Non specificato",
              referente: committente.referenti?.[0]
                ? `${committente.referenti[0].nome} ${committente.referenti[0].cognome}`
                : "Nessun referente",
            })
          );
          setTable(formattedCommittenti);
          onClose(); // Chiude l'offcanvas
        } else {
          console.error("Errore nel caricamento del filtro clienti");
        }
      });
    }
  };

  const handleReset = () => {
    // Resettiamo lo stato globale (padre)
    setFiltroCliente({
      ragioneSociale: "",
      protocollo: "",
      partitaIva: "",
      sdi: "",
      codiceFiscale: "",
      citta: "",
      cap: "",
    });
    // Azzeriamo i filtri di testo locali
    setRagioneSearchText("");
    setPivaSearchText("");
    setSdiSearchText("");
    setProtocolloSearchText("");

    dispatch(allGet(urlcommittenti, token)).then((arrayCantieri) => {
      if (arrayCantieri) {
        const formattedCommittenti = arrayCantieri.map((committente: any) => ({
          ...committente,
          tipologia:
            tipologiaOptions.find(
              (option) => option.value === committente.tipologia
            )?.label || "Non specificato",
          referente: committente.referenti?.[0]
            ? `${committente.referenti[0].nome} ${committente.referenti[0].cognome}`
            : "Nessun referente",
        }));
        setTable(formattedCommittenti);
      } else {
        console.error("Errore nel caricamento del filtro clienti");
      }
    });
  };

  return (
    <div className="form-filtri-clienti">
      <Form.Group className="mb-3">
        <Form.Label htmlFor="ragioneSociale">Ragione Sociale</Form.Label>
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            className="w-100 input-crea-edit p-0 h-2r"
            id="ragioneSocialeDropdown"
          >
            {filtroCliente.ragioneSociale
              ? filtroCliente.ragioneSociale
              : "Seleziona Ragione Sociale"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}
          >
            <FormControl
              autoFocus
              className="w-100"
              placeholder="Filtra per Ragione Sociale"
              onChange={(e) => setRagioneSearchText(e.target.value)}
              value={ragioneSearchText}
            />
            <Dropdown.Divider />

            {committenti
              .filter((c) =>
                c.ragioneSociale
                  ?.toLowerCase()
                  .includes(ragioneSearchText.toLowerCase())
              )
              .map((c, idx) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() =>
                    handleChange("ragioneSociale", c.ragioneSociale)
                  }
                >
                  {c.ragioneSociale}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>

      {/* Protocollo */}
      <Form.Group className="mb-3">
        <Form.Label htmlFor="protocollo">Protocollo (Anno)</Form.Label>
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            id="protocolloDropdown"
            className="w-100 input-crea-edit p-0 h-2r"
          >
            {filtroCliente.protocollo
              ? filtroCliente.protocollo
              : "Seleziona Anno Protocollo"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}
          >
            <FormControl
              autoFocus
              className="w-100"
              placeholder="Filtra per Anno"
              onChange={(e) => setProtocolloSearchText(e.target.value)}
              value={protocolloSearchText}
            />
            <Dropdown.Divider />

            {arrayProtocollo
              .filter((proto) =>
                proto.toLowerCase().includes(protocolloSearchText.toLowerCase())
              )
              .map((proto, idx) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() => handleChange("protocollo", proto)}
                >
                  {proto}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>

      {/* Partita IVA */}
      <Form.Group className="mb-3">
        <Form.Label htmlFor="partitaIva">Partita IVA</Form.Label>
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            className="w-100 input-crea-edit p-0 h-2r"
            id="partitaIvaDropdown"
          >
            {filtroCliente.partitaIva
              ? filtroCliente.partitaIva
              : "Seleziona Partita IVA"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}
          >
            <FormControl
              autoFocus
              className="w-100"
              placeholder="Filtra per Partita IVA"
              onChange={(e) => setPivaSearchText(e.target.value)}
              value={pivaSearchText}
            />
            <Dropdown.Divider />
            {committenti
              .filter((c) =>
                c.partitaIva
                  ?.toLowerCase()
                  .includes(pivaSearchText.toLowerCase())
              )
              .map((c, idx) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() => handleChange("partitaIva", c.partitaIva)}
                >
                  {c.partitaIva}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>

      {/* SDI */}
      <Form.Group className="mb-3">
        <Form.Label htmlFor="sdi">SDI</Form.Label>
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            className="w-100 input-crea-edit p-0 h-2r"
            id="sdiDropdown"
          >
            {filtroCliente.sdi ? filtroCliente.sdi : "Seleziona SDI"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}
          >
            <FormControl
              autoFocus
              className="w-100"
              placeholder="Filtra per SDI"
              onChange={(e) => setSdiSearchText(e.target.value)}
              value={sdiSearchText}
            />
            <Dropdown.Divider />

            {committenti
              .filter((c) =>
                c.sdi?.toLowerCase().includes(sdiSearchText.toLowerCase())
              )
              .map((c, idx) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() => handleChange("sdi", c.sdi)}
                >
                  {c.sdi}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>

      {/* Città, CAP, CodiceFiscale (campi testuali normali) */}
      <Form.Group className="mb-3 w-100">
        <Form.Label htmlFor="citta">Città</Form.Label>
        <Form.Control
          type="text"
          id="citta"
          className="w-100"
          value={filtroCliente.citta}
          onChange={(e) => handleChange("citta", e.target.value)}
          placeholder="Inserisci la città"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label htmlFor="cap">CAP</Form.Label>
        <Form.Control
          type="text"
          id="cap"
          className="w-100"
          value={filtroCliente.cap}
          onChange={(e) => handleChange("cap", e.target.value)}
          placeholder="Inserisci il CAP"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label htmlFor="codiceFiscale">Codice Fiscale</Form.Label>
        <Form.Control
          type="text"
          id="codiceFiscale"
          className="w-100"
          value={filtroCliente.codiceFiscale}
          onChange={(e) => handleChange("codiceFiscale", e.target.value)}
          placeholder="Inserisci il Codice Fiscale"
        />
      </Form.Group>

      {/* Pulsanti */}
      <Row>
        <Col className="text-end">
          <Button variant="secondary" onClick={handleReset}>
            Cancella Filtri
          </Button>
          <Button className="button ms-2" onClick={handleSubmit}>
            Applica Filtri
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default FormFiltriClienti;
